import React from 'react';
import styled from 'styled-components';
import Table from 'rc-table';
import { injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { BaseComponent } from '../../../components/BaseComponent';
import { formatLicensePlate } from '../../../utils/string';

const Container = styled.div`
  width: 100%;
  background: white;
`;

const CustomTable = styled(Table)`
  width: 100%;
  display: flex;
  font-size: 12px;

  .rc-table-container {
    width: 100%;
  }

  .rc-table-content table {
    width: 100%;
  }

  .rc-table-thead {
    background-color: var(--color-new-light);
    font-weight: 600;
    height: 52px;
    padding: 14px 0;
    margin-left: 6px;
    font-size: 14px;
    white-space: nowrap;
  }

  td,
  th {
    padding: 8px 12px;
  }
`;

const DescriptionCell = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 200px;
  justify-content: center;
`;

const formatDate = dateString => {
  if (!dateString) return '-';
  return dayjs(dateString).format('DD-MM-YYYY');
};

class CreditInfoVehiclesTableComp extends BaseComponent {
  getData(vehicle) {
    return vehicle;
  }

  getColumns() {
    return [
      {
        title: this.lblStr('invoice.column.invoice_date'),
        dataIndex: 'invoice_date',
        key: 'invoice_date',
        align: 'left',
        render(value, row, index) {
          return <span>{formatDate(row?.invoice_date)}</span>;
        },
      },
      {
        title: this.lblStr('invoice.column.model'),
        dataIndex: 'description',
        key: 'description',
        align: 'left',
        render(value, row, index) {
          return (
            <DescriptionCell>
              <span style={{ marginBottom: 5 }}>
                <strong>{row?.brand_name}</strong> |<strong>{row?.model_name}</strong> |{row.vin} |
                {formatLicensePlate(row.regplate)}
              </span>
            </DescriptionCell>
          );
        },
      },
      {
        title: this.lblStr('invoice.column.payment_status'),
        dataIndex: 'incoming_invoice_payment_status',
        key: 'incoming_invoice_payment_status',
        align: 'left',
      },
      {
        title: this.lblStr('invoice.column.financial_total_amount'),
        dataIndex: 'financial_total_amount',
        key: 'financial_total_amount',
        align: 'left',
      },
    ];
  }

  render() {
    console.log('this.company?.used_credit_limit_details', this.props.company?.used_credit_limit_details);
    console.log('typeof this.company?.used_credit_limit_details', typeof this.props.company?.used_credit_limit_details);
    console.log(
      'this.company?.used_credit_limit_details?.vehicles',
      this.props.company?.used_credit_limit_details?.vehicles,
    );
    const columns = this.getColumns();
    const data = (this.props.company?.used_credit_limit_details?.vehicles ?? [])?.map(invoice => this.getData(invoice));

    return (
      <Container>
        <CustomTable
          columns={columns}
          data={data}
          scroll={{ x: window.innerWidth < 975 ? 975 : false }}
          emptyText={this.lbl('vehicles.overview.column.no_invoice_found')}
          onRow={(record, index) => ({
            onClick: event => this.to(`/vehicles/${record.id}`, event?.ctrlKey || event?.metaKey),

            vehicle: (this.props.company?.used_credit_limit_details?.vehicles ?? [])[index],
          })}
        ></CustomTable>
      </Container>
    );
  }
}

CreditInfoVehiclesTableComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onItemClick: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const CreditInfoVehiclesTable = compose(withConnect, withRouter, injectIntl)(CreditInfoVehiclesTableComp);
